/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type EditorialModuleArticles_articles = ReadonlyArray<{
    readonly publishedDate: string;
    readonly " $fragmentRefs": FragmentRefs<"ArticleLink_article">;
    readonly " $refType": "EditorialModuleArticles_articles";
}>;
export type EditorialModuleArticles_articles$data = EditorialModuleArticles_articles;
export type EditorialModuleArticles_articles$key = ReadonlyArray<{
    readonly " $data"?: EditorialModuleArticles_articles$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"EditorialModuleArticles_articles">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "EditorialModuleArticles_articles",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedDate",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ArticleLink_article"
    }
  ],
  "type": "WordpressArticleType",
  "abstractKey": null
};
(node as any).hash = 'f8f08a73de896d9a4e8cb43e5ed705d8';
export default node;
